import { Slide } from "@jelly/lesson";
import theory from "../../theory";
import config from "appConfig";

const principle: Slide = {
  description: "Play with the different parameters to see their effect on the apparent resistance and inductance.",
  theory: theory,
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "blockContainer",
        data: {
          block: {
            type: "iframe",
            options: {
              src: `${config.IFRAMES_REACT_URL}/0424/`,
            },
          },
        },
      },
    },
  },
};

export default principle;
